import { Dialog } from "@headlessui/react"
import { KButton, KSpan, KTitleSpan } from "kahuna-base-react-components"
import React, { FC } from "react"

export const UPC_FILTER_OPTIONS = [
  {
    value: "1",
    label: "All complete",
    icon: "/catalog_icons/check-circle.svg",
    rightIcon: "/catalog_icons/check-circle.svg"
  },
  {
    value: "2",
    label: "Spotify complete",
    icon: "/account_icons/social_media_icons/spotify.svg",
    rightIcon: "/catalog_icons/check-circle.svg"
  },
  {
    value: "3",
    label: "Apple complete",
    icon: "/account_icons/social_media_icons/apple-music.svg",
    rightIcon: "/catalog_icons/check-circle.svg"
  },
  {
    value: "4",
    label: "Youtube complete",
    icon: "/account_icons/social_media_icons/youtube.svg",
    rightIcon: "/catalog_icons/check-circle.svg"
  },
  {
    value: "5",
    label: "Not complete",
    icon: "/catalog_icons/close-circle.svg",
    rightIcon: "/catalog_icons/close-circle.svg"
  },
  {
    value: "6",
    label: "Spotify not complete",
    icon: "/account_icons/social_media_icons/spotify.svg",
    rightIcon: "/catalog_icons/close-circle.svg"
  },
  {
    value: "7",
    label: "Apple not complete",
    icon: "/account_icons/social_media_icons/apple-music.svg",
    rightIcon: "/catalog_icons/close-circle.svg"
  },
  {
    value: "8",
    label: "Youtube not complete",
    icon: "/account_icons/social_media_icons/youtube.svg",
    rightIcon: "/catalog_icons/close-circle.svg"
  }
]

type UpcSelectionModalProps = {
  open: boolean
  description?: string
  onSelect: (value: string) => void
  onClose: () => void
}

const UpcSelectionModal: FC<UpcSelectionModalProps> = (props) => {
  return (
    <Dialog open={props.open} onClose={props.onClose}>
      <div className="fixed w-screen h-screen top-0 left-0 z-250 flex items-center justify-center bg-[#0000004d]">
        <div
          className="p-6 shadow-md w-[420px] rounded-[10px] bg-[#fff]"
          style={{ maxHeight: "90vh", overflowY: "auto" }}
        >
          <div className="flex flex-col gap-5">
            <div className="flex flex-col gap-1">
              <KTitleSpan text="Select Releases" fontSize={20} lineHeight="28px" />
              <KSpan
                text={props.description || "Choose which releases the UPC list should include."}
                fontSize={12}
                lineHeight="16px"
                color="#6B7280"
              />
            </div>
            <div className="flex flex-col gap-2">
              {UPC_FILTER_OPTIONS.map((option) => (
                <div
                  key={option.value}
                  data-testid={`upc-filter-option-${option.value}`}
                  className="flex gap-2 border border-[#E5E7EB] rounded-[10px] p-3 cursor-pointer hover:bg-[#F7F7F7]"
                  onClick={() => props.onSelect(option.value)}
                >
                  <img src={option.rightIcon} alt={`${option.label}_left`} className="w-5 h-5" />
                  <KSpan text={option.label} color="#111" />
                  <img src={option.icon} alt={`${option.label}_right`} className="w-5 h-5" />
                </div>
              ))}
            </div>
            <div className="flex justify-end">
              <KButton
                dataTestId="upc-selection-cancel-button"
                width="120px"
                text="Cancel"
                background="#fff"
                onClick={props.onClose}
              />
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  )
}

export default UpcSelectionModal
